import { makeStyles } from "@fluentui/react-components";
import { ProjectManagementPage } from "apps/decooda/components/projects/ProjectManagementPage";
import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { designTokens } from "theme/customTheme";

const useStyles = makeStyles({
  container: {
    display: "flex",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: designTokens.neutral[50],
  },
  navPanel: {
    display: "flex",
    flexWrap: "wrap",
    height: "100dvh",
    backgroundColor: designTokens.neutral[50],
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    height: "100dvh",
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral[50],
    overflowY: "auto",
    overflowX: "hidden",
  },
});

export const DecoodaProjectManagementMain = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.navPanel}>
        <NavigationPanel />
      </div>
      <div className={styles.contentContainer}>
        <ProjectManagementPage />
      </div>
    </div>
  );
};
